function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M176.852 10.27H165.52v141.103a4.15 4.15 0 01-4.148 4.147H20.268v11.333A4.15 4.15 0 0024.417 171h152.435a4.15 4.15 0 004.148-4.147V14.417a4.148 4.148 0 00-4.148-4.147z",
  fill: "#F2F2F2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M155.943 141.793V-5.851A4.151 4.151 0 00151.795-10H4.149A4.152 4.152 0 000-5.851v147.648a4.15 4.15 0 004.149 4.146h147.646a4.15 4.15 0 004.148-4.15zM113.507 20.636c8.749 0 15.846 7.092 15.846 15.846 0 8.75-7.097 15.843-15.846 15.843-8.749 0-15.846-7.092-15.846-15.843-.001-8.754 7.095-15.846 15.846-15.846zm-99.97 112.153c.817-17.916 10.179-52.728 23.82-65.553 12.214-11.4 22.599-1.425 30.743 10.178 7.531 10.788 14.087 20.334 19.61 26.333 9.093 9.09 16.86-4.691 26.395-9.232 13.897-6.614 25.347 27.791 28.299 38.316l-128.866-.042z",
  fill: "#F2F2F2"
});

var SvgPhotoIcon = function SvgPhotoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 181 171",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhotoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo-icon.faa334be.svg";
export { ForwardRef as ReactComponent };